import { clsx } from '../functions'
import { inputOnKeyUp } from "../functions.ts";
import './measure.css'

export default function Measure(props:{label: string, now?: string, future?: string, onClick: () => void}) {   
  const future = props.future && props.future.trim();

  return (
     <div 
        className='measure' 
        tabIndex={0} 
        role="button"
        aria-label={props.label}
        aria-description={
          `Wert aktuell: ${props.now || "nicht definiert"}, Wert nach Sanierung: ${props.future || "nicht definiert"}`
        }
        onClick={props.onClick}
        onKeyUp={(event)=>inputOnKeyUp(event, ()=>{
          props.onClick();
          setTimeout(() => {
            document.querySelector(".modal [tabindex]").focus();
          }, 100); 
        })}
      >
      <div aria-hidden className='measure__label'>{props.label}</div>
      <div aria-hidden className='measure__infos'>
        <div aria-hidden className={clsx('measure__info-now', !future && 'measure__info-now--single')}>{props.now ? props.now : "unsaniert"}</div>
        {
          future && <>
            <div className='measure__info-triangle'></div>
            <div className='measure__info-future'>{props.future}</div>
          </>   
        }
      </div>
     </div>
  )
}